/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menulunchpast2Inputs */

const en_menulunchpast2 = /** @type {(inputs: Menulunchpast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no dishes for today or the coming days – guests can’t see this lunch menu right now.`)
};

const de_menulunchpast2 = /** @type {(inputs: Menulunchpast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für heute und die kommenden Tage stehen keine Gerichte drin – Gäste sehen dieses Mittagsmenü gerade nicht.`)
};

/**
* | output |
* | --- |
* | "There are no dishes for today or the coming days – guests can’t see this lunch menu right now." |
*
* @param {Menulunchpast2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menulunchpast2 = /** @type {((inputs?: Menulunchpast2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menulunchpast2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menulunchpast2(inputs)
	return de_menulunchpast2(inputs)
});
export { menulunchpast2 as "menuLunchPast" }